import React from "react";
import { func } from "prop-types";
import I18n from "pages/_components/I18n";
import FilterForm from "pages/echeck/Echecks/components/FilterForm";
import { today, date7DaysBefore, date7DaysAfter } from "pages/echeck/utils";

const ReceivedSideBarForm = ({ closeSidebar }) => {
    const initialValues = {
        createdRange: [date7DaysBefore, today],
        payedRange: [today, date7DaysAfter],
    };

    return (
        <div className="container full-width">
            <I18n id="echecks.filter" component="h2" />
            <FilterForm isRecievedForm customValues={initialValues} closeSidebar={closeSidebar} />
        </div>
    );
};

ReceivedSideBarForm.propTypes = {
    closeSidebar: func.isRequired,
};

export default ReceivedSideBarForm;
